var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3625_25004)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#009B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.49976 9.24467H15.4968V7.94217H4.49976V6.66467C4.49976 6.15967 4.91926 5.74692 5.43226 5.74692H14.5658C15.0788 5.74692 15.4998 6.15992 15.4998 6.66442V13.0792C15.4998 13.5842 15.0803 13.9967 14.5673 13.9967H5.43226C4.91926 13.9967 4.49976 13.5842 4.49976 13.0792V9.24442V9.24467ZM7.82801 11.7217C7.8922 11.6574 7.92826 11.5704 7.92826 11.4795C7.92826 11.3887 7.8922 11.3016 7.82801 11.2374L6.58926 9.99967L5.35051 11.2372C5.30257 11.285 5.26988 11.3459 5.25656 11.4123C5.24325 11.4787 5.2499 11.5475 5.27569 11.6101C5.30148 11.6727 5.34525 11.7263 5.40146 11.764C5.45767 11.8018 5.5238 11.822 5.59151 11.8222C5.68001 11.8222 5.76451 11.7889 5.83151 11.7217L6.23751 11.3107V12.9072C6.23751 13.0959 6.40026 13.2497 6.58926 13.2497C6.77801 13.2497 6.94076 13.0959 6.94076 12.9072V11.3107L7.34676 11.7217C7.37823 11.7535 7.41571 11.7787 7.45701 11.796C7.49831 11.8132 7.54263 11.8221 7.58738 11.8221C7.63214 11.8221 7.67645 11.8132 7.71775 11.796C7.75905 11.7787 7.79653 11.7535 7.82801 11.7217Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3625_25004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecharge);
export default __webpack_public_path__ + "static/media/recharge.fab5febb9edb0ce9afee5acacda38d9a.svg";
export { ForwardRef as ReactComponent };